import { useNavigate } from 'react-router-dom'
import { LanguageSwitcher, Logo } from '../../atoms'
import { useI18n } from '../../../../i18n/i18n'
import './header.scss'

export function Header() {
  const navigate = useNavigate()
  const { t } = useI18n()

  return (
    <header className="container__header">
      <div className="container__header-logo" onClick={() => navigate('/')}>
        <Logo />
      </div>

      <nav className="nav__header">
        <button onClick={() => navigate('/')}>{t('nav.inicio')}</button>
        <button onClick={() => navigate('/servicos')}>{t('nav.servicos')}</button>
        <button onClick={() => navigate('/quem-somos')}>{t('nav.sobre')}</button>
      </nav>

      <div className="header__right">
        <LanguageSwitcher />
        <button className="btn btn-primary header__cta" onClick={() => navigate('/contato')}>
          {t('nav.contato')}
        </button>
      </div>
    </header>
  )
}
